export const MAX_SUGGESTIONS_PER_GROUP = 5;
